// Returns the full URL without querystring parameters (optionally including hash).
export const getOriginatingUrl = (includeHash = false): string => {
    if (typeof window === 'undefined' || !window.location) {
        return '';
    }

    const { origin, pathname, hash } = window.location;

    if (includeHash && hash) {
        return `${origin}${pathname}${hash}`;
    }

    return `${origin}${pathname}`;
};

export default getOriginatingUrl;
